import { initStores } from '~/store';

declare global {
  interface Window {
    MSStream: boolean;
  }
}

export {};

export function useAppInit() {
  const gtag = useGtag();
  const bidrPixel = useBidrPixel();

  const runAppInitActions = () => {
    initStores();
  };

  onMounted(() => {
    const isAppleDevice = /iPad|iPhone|iPod|Mac\sOS/.test(navigator.userAgent) && !window.MSStream;
    if (isAppleDevice) {
      document.documentElement.classList.add('apple-device');
    }

    const isOldSafari =
      /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) && !CSS.supports('text-wrap', 'balance');
    if (isOldSafari) {
      document.documentElement.classList.add('old-safari');
    }

    gtag.initConversionId();
    bidrPixel.fetchPageVisitPixel();
  });

  return {
    runAppInitActions,
  };
}
